module.exports = __webpack_public_path__ + "assets/0449803d7b3fd1c7e7d0b6c726a384e3.png";